import { Storage as ServerIcon } from '@mui/icons-material';
import { Box, IconButton, LinearProgress, styled, Typography } from '@mui/material';

export const CardHeader = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  paddingBottom: 0,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
}));

export const CardTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.125rem',
  fontWeight: 600,
  marginBottom: theme.spacing(0.5),
}));

export const CardDescription = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: theme.palette.text.secondary,
}));

export const StyledLinearProgress = styled(LinearProgress)(() => ({
  height: 8,
  borderRadius: 4,
}));

export const JsonDisplay = styled(Box)(({ theme }) => ({
  backgroundColor: '#1e1e1e',
  color: '#d4d4d4',
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  fontFamily: 'monospace',
  fontSize: '0.875rem',
  whiteSpace: 'pre-wrap',
  overflowX: 'auto',
  maxHeight: '400px',
  overflowY: 'auto',
}));

export const ActionButton = styled(IconButton)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1),
}));

export const LoadingContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  padding: 32,
});

export const StatusIconContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'status',
})<{ status: string }>(({ status }) => ({
  padding: 12,
  borderRadius: '50%',
  backgroundColor: status === 'ok' ? '#e6f7ed' : '#fdeded',
}));

export const StatusIcon = styled(ServerIcon, {
  shouldForwardProp: (prop) => prop !== 'status',
})<{ status: string }>(({ theme, status }) => ({
  color: status === 'ok' ? theme.palette.success.main : theme.palette.error.main,
}));

export const StatusContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  marginBottom: 24,
});

export const StatusTextContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
});

export const SectionContainer = styled(Box)<{ mb?: number }>(({ mb = 4 }) => ({
  marginBottom: mb * 8,
}));

export const ServiceIndicator = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'connected',
})<{ connected: boolean }>(({ theme, connected }) => ({
  width: 10,
  height: 10,
  borderRadius: '50%',
  backgroundColor: connected ? theme.palette.success.main : theme.palette.error.main,
}));

export const CardBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: 12,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
}));

export const InfoBox = styled(Box)(({ theme }) => ({
  padding: 16,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
}));

export const SystemContainer = styled(Box)(({ theme }) => ({
  padding: 16,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
}));

export const InfoItem = styled(Box)<{ mb?: number }>(({ mb = 2 }) => ({
  marginBottom: mb * 8,
}));

export const ProgressContainer = styled(Box)({
  marginTop: 8,
});
